import { db } from '../../firebase/config'
import { client } from '../../hooks/Client'
import notDeleted from '../notDeleted'

/**
 * Leest één huishouden van de eigen organisatie op zijn `ID`-veld — het
 * leespad dat elke nabehandeling van een huisbezoek nodig heeft (status
 * automatisch zetten, label weghalen).
 *
 * Eén plek, omdat drie helpers elk hun eigen kopie hadden en die het oneens
 * waren over een verwijderd document: twee pakten `docs[0]`, één filterde op
 * `Deleted`. Hier geldt één regel: het eerste LEVENDE document.
 * AI-CONTEXT: See docs/pitfalls.md#dev-copied-recipe-instead-of-shared-hook
 * AI-CONTEXT: See docs/pitfalls.md#database-missing-compagnyid-on-fresh-fetch
 *
 * @param {string} [adressId] - `Adresses.ID` (niet de docid)
 * @returns {Promise<import('firebase/compat/app').default.firestore.QueryDocumentSnapshot|null>} Het document, of null als het er niet (meer) is
 */
const fetchOwnAdress = async (adressId) => {
    if (!adressId || !client) return null

    const snap = await db.collection('Adresses')
        .where('CompagnyID', '==', client)
        .where('ID', '==', adressId)
        .get()

    return snap.docs.find((doc) => notDeleted(doc.data())) || null
}

export default fetchOwnAdress
